import { storyblokEditable, renderRichText } from "@storyblok/react";

const CardHero = ({ blok }) => {
  return (
    <div
      {...storyblokEditable(blok)}
      className="font-display card-hero-wrapper"
    >
      <div className="card card-hero">
        <div className="card-image">
          <img src={blok.cardimage.filename} alt={blok.cardimage.alt} />
        </div>
        <div className="card-detail">
          <p className="preamble">{blok.preamble}</p>
          <h3>{blok.title}</h3>
          <div
            className="desc"
            dangerouslySetInnerHTML={{
              __html: renderRichText(blok.description),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CardHero;
